import React, { useState, useEffect } from 'react';
import iconCellPhone from '../../icons/icon-cell-phone.svg';
import iconTv from '../../icons/icon-tv.svg';
import iconInternet from '../../icons/iconInternet.svg';
import iconPlane from '../../icons/iconPlane.svg';
import exclamationMark from '../../icons/exclamation_mark.svg';
import iconStar from '../../icons/icon-star.svg';
import iconPhone from '../../icons/icon-phone.svg'
import Image from 'app/Components/Shared/Image/image';
export default function ProductsNames(props) {
  const { invoicesInfo } = props;
  const [index, setIndex] = useState();
  const [offsetList, setOffsetList] = useState([]);

  useEffect(() => {
    const features = invoicesInfo?.generalTab?.fitcherData?.fitcher;
    if (!features) { return; }

    for (let i = 0; i < features.length; i++) {
      const offsetTop = document.getElementById(`section-${i}`)?.offsetTop;
      setOffsetList(offsetList => [...offsetList, offsetTop]);
    }
  }, []);

  const clickingProduct = (i) => {
    setIndex(i);
    const offsetTop = offsetList[i];
    window.scrollTo({ top: offsetTop - 270, behavior: 'smooth' });
  };

  return (
    <div className='wrapper-info-product'>
      <div className='total-price'>
        <div className='wrapper-price'>
          <div className='container-price'>
            <div>סה"כ</div>
            <div className='price'>
              {invoicesInfo?.generalTab?.fitcherData?.fullPrice?.amount}.{invoicesInfo?.generalTab?.fitcherData?.fullPrice?.amountAgorot}
              {invoicesInfo?.generalTab?.fitcherData?.fullPrice?.isAmountMinus && <div className='price-range'>-</div>}
              <span className='nis'>₪</span>
            </div>
          </div>
        </div>
      </div>
      <div className='wrapper-division-products'>
        {invoicesInfo?.generalTab?.fitcherData?.fitcher?.map((product, i) => {
          let icon;
          switch (product.title.toUpperCase()) {
            case 'CELLULAR':
              icon = iconCellPhone;
              break;
            case 'MAPA':
              icon = iconPhone;
              break;
            case 'TV':
              icon = iconTv;
              break;
            case 'INTERNET':
              icon = iconInternet;
              break;
            // case 'ENERGY':
            //   icon = '';
            //   break;
            case 'DEBT':
              icon = exclamationMark;
              break;
            case 'ABROAD':
              icon = iconPlane;
              break;
            case 'GENERAL':
              icon = iconStar;
              break;
            default:
              icon = ''; // אייקון ברירת מחדל
          };
          return (
            <>
              {
                product.title.toUpperCase() == 'DEBT' ? (
                  <div className='product' key={i}>
                    <div className='row-detail-product'>
                      <div> <Image src={icon} alt='icon' /> </div>
                      <div className='name-number-product'>
                        <div>{product?.titleText}</div>
                      </div>
                    </div>
                    <div className='price'>
                      ₪{product.amountFitcher.amount}.{product.amountFitcher.amountAgorot}
                      {product.amountFitcher.isAmountMinus ? '-' : ''}
                    </div>
                  </div>
                ) : (
                  <button key={i} className='product' onClick={() => clickingProduct(i)} >
                    <div className='row-detail-product'>
                      <div>
                        {product.title !== 'ENERGY' && <Image src={icon} alt='icon' />}
                      </div>
                      <div className='name-number-product'>
                        <div> {product?.titleText} </div>
                        {product?.countFitcher > 1 && <div className='number-subscribers'>({product?.countFitcher} מנויים)</div>}
                        {product?.addName && <div className='number-subscribers'>{product?.addName}</div>}
                      </div>
                    </div>
                    <div className='price'>
                      ₪{product.amountFitcher.amount}.{product.amountFitcher.amountAgorot}
                      {product.amountFitcher.isAmountMinus ? '-' : ''}
                    </div>
                  </button>
                )
              }
            </>
          );
        })}
      </div>
    </div>
  );
}
